<!--
 * @Description: 
 * @Author: fal
 * @Date: 2025-02-28 14:37:44
 * @FilePath: \xhlz_pc\src\project\components\login.vue
 * @LastEditTime: 2025-09-08 15:05:33
-->
<template>
  <el-dialog class="login-modal" :visible="visible" width="770px" :show-close="false" :close-on-click-modal="false" append-to-body @close="handleClose" @open="init">
    <updatePassword v-if="showType == 3" @gologin="showType = 1" @lookAgreement="viewVisible = true" />
    <sign v-else-if="showType == 2" @gologin="showType = 1" @lookAgreement="viewVisible = true" />
    <subLogin v-else @gosign="showType = 2" @gopass="showType = 3" />

    <img src="@/project/assets/front/icon-login-close.png" alt="" class="login-close" @click="handleClose" />

    <!-- 查看 -->
    <viewAgreement :visible="viewVisible" :type="0" @close="viewVisible = false" />
  </el-dialog>
</template>

<script>
import updatePassword from './login/updatePassword.vue';
import subLogin from './login/login.vue';
import sign from './login/sign.vue';
export default {
  name: 'login',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number || String,
      default: 1, // 1 登录 2 注册 3 找回密码
    },
  },
  components: {
    updatePassword,
    subLogin,
    sign,
  },
  data() {
    return {
      showType: 1,
      viewVisible: false,
      dialogVisible: false,
    };
  },
  methods: {
    init() {
      this.showType = Number(this.type);
    },
    handleClose() {
      this.$emit('close');
      this.showType = 1;
    },
  },
};
</script>

<style lang="less" scoped>
.login-modal {
  :deep(.el-dialog) {
    position: relative;
    border-radius: 4px;
    .el-dialog__title {
      font-size: 20px;
      font-weight: 800;
      line-height: 24px;
      color: #333;
    }
    .el-dialog__body {
      padding: 20px 40px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
    }
  }

  .login-close {
    position: absolute;
    bottom: -110px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 56px;
    height: 56px;
    cursor: pointer;
  }
}
</style>
